import React, { useEffect, useState } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { observer } from 'mobx-react-lite'
import { ResourceApi } from '@trivie/core/src/services/api-objects'
import { CircularProgress } from '@mui/material'
import { useStores } from '@trivie/core'
import { DateTime } from 'luxon'

export const ImageNode = observer((props: any) => {
  const { utilityStore } = useStores()
  const { sourceRefresh } = utilityStore
  const { setSourceRefresh } = utilityStore
  const [source, setSource] = useState('')

  const load = async () => {
    if (!source) {
      const res = await ResourceApi.getSourceDetails(props.node.attrs.source_id)
      setSource(res.data.filename_or_url)
      setSourceRefresh(props.node.attrs.source_id, Date.now())
      return res
    }
  }

  useEffect(() => {
    load()
    // const lastRefresh = sourceRefresh?.get(props.node.attrs.source_id)
    // if (source && lastRefresh) {
    //   const expired = DateTime.fromMillis(lastRefresh).diffNow('minutes').minutes < -15
    //   if (expired) {
    //     reload()
    //   }
    // } else {
    //   reload()
    // }
  }, [props.node.attrs.source_id])

  return (
    <NodeViewWrapper>
      {source ? (
        <img src={source} />
      ) : (
        <CircularProgress style={{ margin: '0 auto', display: 'flex', alignSelf: 'center' }} />
      )}
    </NodeViewWrapper>
  )
})
